import { useCallback } from "react";
import { LicensesApi, useAPIAction } from "melco-shared-logic";

export const useResendEmail = () => {
  const [resendEmail] = useAPIAction(
    LicensesApi,
    async (api, serialNumber: string) => {
      await api.resendEmailSerialNumber({
        serialNumber: serialNumber,
      });

      return {
        successMessages: [{ message: "default" }],
        // data,
      };
    },
    {
      translationPrefix: "licenses.basic.detail.resendemail",
    }
  );

  return useCallback(
    async (serialNumber: string) => {
      try {
        return await resendEmail(serialNumber);
      } catch (e) {
        // error handling is already done in useAPIAction
      }
    },
    [resendEmail]
  );
};
